import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export const isValidEVMAddress = (address) => {
  return /^0x[a-fA-F0-9]{40}$/.test(address);
};
